import { Box, Typography, useTheme } from "@mui/material"
import { type ReactNode, isValidElement } from "react"

export const FieldSectionTitle = ({ title }: { title: ReactNode }) => {
  const {
    palette: { common },
  } = useTheme()

  return (
    <Box
      sx={{
        mx: 3,
        mt: 3,
        p: 0.75,
        pl: 1.5,
        borderRadius: 1.5,
        bgcolor: common.paleCyan,
      }}
    >
      {isValidElement(title) ? (
        title
      ) : (
        <Typography fontWeight={500} sx={{ color: common.darkBlue }}>
          {title}
        </Typography>
      )}
    </Box>
  )
}
